export default __webpack_public_path__ + "static/media/Screenshot (1071).2afc5b91.png";